<template>
  <section class="pdx-small-desktop">
    <div v-for="row of dataset" :key="row.value">
      <h1
        class="
          subtitle
          is-size-6-mobile is-size-4-desktop
          my-5
          has-text-weight-bold
        "
      >
        {{ row.key }}
      </h1>
      <b-progress
        type="is-primary is-large"
        :value="row.value"
        :max="row.max"
        show-value
      ></b-progress>
    </div>
  </section>
</template>
<script>
  export default {
    props: {
      dataset: Array,
    },
    data() {
      return {
        data: this.dataset,
      };
    },
  };
</script>
